var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header clearfix"},[_c('div',{staticClass:"title"},[_vm._t("default"),_c('span')],2),(_vm.show)?_c('img',{attrs:{"src":require('../assets/images/swag.png'),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }